import React from "react";
import { Row, Col } from "react-bootstrap";
import { AdminDashboardUser } from "@preveil-api";
import { account_types, DashboardUsage, getAccountTooltip } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  user: AdminDashboardUser;
}

// Description: Render the list row for the dashboard users table
function ListRowComponent(props: AllProps) {
  const { user } = props;

  return <Row>
    <Col md="3">
      <Icon
        tooltip={getAccountTooltip(user.account_type)}
        className={`account-type-icon ${user.account_type === account_types.full ? "icon-user-plus" : user.account_type === account_types.express ? "icon-user" : "icon-user-plus inactive"}`} />
      <span>{user.display_name}</span>
    </Col>
    <Col md="3">
      <span>{DashboardUsage.convertUsageToFriendlySizeList(user.private_usage)}</span>
    </Col>
    <Col md="3">
      <span>{DashboardUsage.convertUsageToFriendlySizeList(user.shared_storage)}</span>
    </Col>
    <Col md="2">
      <span>{user.file_count}</span>
    </Col>
  </Row>;
}

export default React.memo(ListRowComponent);
